module.exports = __webpack_public_path__ + "public/img/img-1.4e92c304.jpg";